(function () {
    'use strict';

    angular
        .module('ib-pmt-services-http-module')
        .factory('PmtMethodsProxy', PmtMethodsProxy);

    PmtMethodsProxy.$inject = ['$http', '$q'];
    function PmtMethodsProxy($http, $q) {
        var service = {
            getPaymentMethods: getPaymentMethods,
            getPaymentAdditionalFields: getPaymentAdditionalFields,
            updatePaymentAdditionalFields: updatePaymentAdditionalFields,
            updatePaymentsInfo: updatePaymentsInfo
        };

        return service;

        ////////////////
        /**
         * Calls HTTP GET method to the obtain the available payment methods for a booking purchase
         * @param {string} url - the http url of the get payment methods rest service
         * @returns {Object.<Promise>} - returns the $http promise. When the promise resolves, it returns an object with the response data and the response status.
         *  When the promise rejects, it returns an object with the response error data and the response error code.
         */
        function getPaymentMethods(url) {
            return $http.get(url).then(getPaymentMethodsComplete)['catch'](getPaymentMethodsFailed);

            function getPaymentMethodsComplete(response) {
                return { data: response.data, code: response.status };
            }

            function getPaymentMethodsFailed(response) {
                return $q.reject({ data: response.data, errorCode: response.status });
            }
        }

        ////////////////
        /**
         * Calls HTTP GET method to the obtain the additional payment fields for a booking purchase
         * @param {string} url - the http url of the get payment additional fields rest service
         * @returns {Object.<Promise>} - returns the $http promise. When the promise resolves, it returns an object with the response data and the response status.
         *  When the promise rejects, it returns an object with the response error data and the response error code.
         */
        function getPaymentAdditionalFields(url) {
            return $http.get(url).then(getPaymentAdditionalFieldsComplete)['catch'](getPaymentAdditionalFieldsFailed);

            function getPaymentAdditionalFieldsComplete(response) {
                return { data: response.data, code: response.status };
            }

            function getPaymentAdditionalFieldsFailed(response) {
                return $q.reject({ data: response.data, errorCode: response.status });
            }
        }

        ////////////////
        /**
         * Calls HTTP POST method to uodate the additional payment fields for a booking purchase
         * @param {string} url - the http url of the get payment additional fields rest service
         * @param {Object} requestData - the request form data to call the webservice with the update Request Body.
         * @returns {Object.<Promise>} - returns the $http promise. When the promise resolves, it returns an object with the response data and the response status.
         *  When the promise rejects, it returns an object with the response error data and the response error code.
         */
        function updatePaymentAdditionalFields(url, requestData) {
            return $http.post(url, angular.toJson(requestData)).then(updatePaymentAdditionalFieldsComplete)['catch'](updatePaymentAdditionalFieldsFailed);

            function updatePaymentAdditionalFieldsComplete(response) {
                return { data: response.data, code: response.status };
            }

            function updatePaymentAdditionalFieldsFailed(response) {
                return $q.reject({ data: response.data, errorCode: response.status });
            }
        }

        ////////////////
        /**
         * Calls HTTP POST method to uodate the additional payment fields for a booking purchase
         * @param {string} url - the http url of the get payment additional fields rest service
         * @param {string} checkinId - the checkinId of the session
         * @param {Object} requestData - the request form data to call the webservice with the update Request Body.
         * @returns {Object.<Promise>} - returns the $http promise. When the promise resolves, it returns an object with the response data and the response status.
         *  When the promise rejects, it returns an object with the response error data and the response error code.
         */
        function updatePaymentsInfo(url, checkinId, requestData) {

            return $http.post(url + checkinId + '/ancillaries/pay-and-issue', angular.toJson(requestData)).then(updatePaymentsComplete)['catch'](updatePaymentsFailed);

            function updatePaymentsComplete(response) {
                return response.data;
            }

            function updatePaymentsFailed(response) {
                return $q.reject({ data: response.data, errorCode: response.status });
            }
        }
    }
})();
